export type UnionToType<U extends Record<string, unknown>> = {
  [K in U extends unknown ? keyof U : never]: U extends unknown ? (K extends keyof U ? U[K] : never) : never;
};

export type StatusPayment = 'unpaid' | 'pending' | 'paid';

export interface Locale {
  close: string;
  back?: string;
  last?: string;
  next?: string;
  open?: string;
  skip?: string;
}

export interface DashboardSettings {
  org_id: number;
  base_url: string;
  dashboards: {
    legal: string;
    logistic: string;
    financial: string;
  };
}
export interface Permission {
  id: number;
  name: string;
}

export interface Role {
  id: number;
  access_group_id: number | null;
  name: string;
  permissions: Permission[];
}
export interface AccessGroup {
  id: number;
  name: string;
  display_name: string;
  dashboard_settings: DashboardSettings;
}

export interface User {
  id: number;
  name: string;
  email: string;
  first_login: boolean;
  tutorial: {
    financial: boolean;
  };
  profile_id: number;
  access_groups: AccessGroup[];
  roles: Role[];
}

export enum InvoiceStatus {
  WaitingForInvoice = 'Aguardando boleto',
  InvoiceAvailable = 'Boleto disponível',
  InvoiceUpdated = 'Boleto atualizado',
  InvoicePaid = 'Boleto pago',
  InvoiceConcluded = 'Boleto quitado'
}

export type StepType = {
  label: string;
  date: string | null;
  active: boolean;
};

interface InfractionData {
  id: number;
  auto_infraction: string;
  date_auto_infraction: string;
  vehicle: string;
  cart: string;
  truck: string | null;
  driver: string;
  transport: string;
  loc_org: string;
  loc_org_name: string;
  ag_freight: string;
  ag_name: string;
  date_ini: string;
  date_end: string;
  supply: string;
  invoice: string;
  product: string;
  gv: string;
}

export interface InfractionResponse {
  status: string;
  message: string | null;
  integration_active: boolean;
  last_sync_attempt: string | null;
  data: InfractionData[];
}

export interface DraggableDialogProps {
  open: boolean;
  data: InfractionData[];
  onClose: () => void;
}

export interface PdfThumbnailProps {
  file: File;
  preview: string;
  onLoad: () => void;
}

export interface RenderPdfThumbnailParams {
  url: string;
  width: number;
  height: number;
  zoom?: number;
}
